import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { SituViewWebApiClient } from 'situview-webapi-client';
import { PanoramaService } from 'src/app/services';
import { IFloorplanSettings } from '../../shared/models/floorplan-settings.interface';

@Component({
  selector: 'app-home-config-settings',
  templateUrl: './home-config-settings.component.html',
  styleUrls: ['./home-config-settings.component.less']
})
export class HomeConfigSettingsComponent implements OnInit, AfterViewInit {

  @Input() onPluginManagerLoad: ReplaySubject<any> | undefined;
  @Output() hideControls = new EventEmitter<boolean>();
  @Input() floorplanSettings: IFloorplanSettings | undefined;
  @Output() floorplanSettingsChange = new EventEmitter<IFloorplanSettings>();

  @Input() floorPlanInteractive = true;
  @Output() floorPlanInteractiveChange = new EventEmitter<boolean>();

  // Setting Sets
  panoramaRes = [4096, 2048, 1024]
  panoramaFOV = [70, 75, 80, 90, 95, 100, 110, 115]
  fPColors = ["default", "lightgray", "lightblue", "white", "black", "blue", "yellow", "green", "lightgreen"]
  selectedFOV: number | undefined;
  pluginManager: any;
  situSystems: any;

  constructor(private panoramaService: PanoramaService, private situViewClient: SituViewWebApiClient) { }

  ngOnInit(): void {
    this.selectedFOV = this.panoramaFOV[3];
  }

  ngAfterViewInit(){
    this.onPluginManagerLoad?.subscribe(x => this.init(x));
  }


  init(pluginManager:any) {
    this.situSystems = this.panoramaService.situSystems;
    this.pluginManager = pluginManager;
  }

  setFOV(value:any) {
    this.pluginManager.getPlugin("SituPanoramaViewer").settings.fieldOfView = value;
  }

  setRes(value:any) {
    this.pluginManager.getPlugin("SituPanoramaViewer").settings.imageSize = value;
  }

  setFPRotation(value: number) {
    (this.floorplanSettings as IFloorplanSettings).planImageRotation = value;
    this.floorplanSettingsChange.emit(this.floorplanSettings);
  }

  setFPColor(value: string) {
    (this.floorplanSettings as IFloorplanSettings).floorPlanColour = value;
    this.floorplanSettingsChange.emit(this.floorplanSettings);
  }

  setFPOptionColor(value: string) {
    (this.floorplanSettings as IFloorplanSettings).optionColour = value;
    this.floorplanSettingsChange.emit(this.floorplanSettings);
  }

  setFPHighlightColor(value: string) {
    (this.floorplanSettings as IFloorplanSettings).roomHighlightColour = value;
    this.floorplanSettingsChange.emit(this.floorplanSettings);
  }

  setFont(value: string) {
    let font = "default";
    if (value != "default") {
      font = "../../../assets/fonts/" + value;
    }

    (this.floorplanSettings as IFloorplanSettings).roomNameFontURL = font;
    this.floorplanSettingsChange.emit(this.floorplanSettings);
  }

  setFontSize(value: string) {
    (this.floorplanSettings as IFloorplanSettings).roomNameFontSize = value;
    this.floorplanSettingsChange.emit(this.floorplanSettings);
  }

  setFloorPlanInteraction(value: boolean) {
    this.floorPlanInteractive = value;
    this.floorPlanInteractiveChange.emit(this.floorPlanInteractive);
  }

  setShowControls(value: boolean) {
    this.hideControls.emit(value);
  }
}
